@if(orders) {
  <mat-card class="p-md-0 shadow">
    <mat-card-header>
      <mat-card-title>Shopping Cart</mat-card-title>
    </mat-card-header>
    <table mat-table [dataSource]="orders" class="my-2 mx-0">
  
      <!-- Item Column -->
      <ng-container matColumnDef="item">
        <th mat-header-cell *matHeaderCellDef> ORDER ITEMS </th>

        <td mat-cell *matCellDef="let order" class="external-padding"> 
          @for(purchaseItem of order.purchaseItems; track purchaseItem.referenceId) {
            <tr>
              <td class="internal-padding">
                {{purchaseItem.description}}
              </td>
            </tr>
          }
        </td>

        <!-- FOOTER -->
        <td mat-footer-cell *matFooterCellDef> Order Subtotal <span class="light"> ({{subtotalItems}} items) </span> </td>
      </ng-container>
  
      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef> PRICE </th>
        <td mat-cell *matCellDef="let order" class="external-padding">
          @for(purchaseItem of order.purchaseItems; track purchaseItem.referenceId) {
            <div>
              <div class="internal-padding">
                {{purchaseItem.unitAmount | amount | currency}}
              </div>
            </div>
          }
        </td>
        <td mat-footer-cell *matFooterCellDef> </td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef class="quantity"> QUANTITY </th>
        <td mat-cell *matCellDef="let order" class="external-padding">
          @for(purchaseItem of order.purchaseItems; track purchaseItem.referenceId) {
            <div>
              <div class="internal-padding text-align-center">
                {{ purchaseItem.quantity| number:'2.0-0' }}
              </div>
            </div>
          }
        </td>
        <td mat-footer-cell *matFooterCellDef> </td>
      </ng-container>

      <ng-container matColumnDef="remove">
        <th mat-header-cell class="text-align-center" *matHeaderCellDef>REMOVE</th>
        <td mat-cell *matCellDef="let order" class="external-padding text-align-center">
          <mat-icon class="icon" (click)="removeFromCart(order)">delete</mat-icon>
        </td>
        <td mat-footer-cell *matFooterCellDef> </td>
      </ng-container>

      <!-- Cost Column -->
      <ng-container matColumnDef="cost">
        <th mat-header-cell *matHeaderCellDef class="text-align-right"> SUBTOTAL </th>
        <td mat-cell *matCellDef="let order" class="external-padding">
          @for(purchaseItem of order.purchaseItems; track purchaseItem.referenceId) {
            <div>
              <div class="text-align-right internal-padding">
                {{purchaseItem.total | amount  | currency}}
              </div>
            </div>
          }
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-align-right extra"> {{ total | amount | currency}} </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
    </table>
  </mat-card>
}  
